import { BRAND } from '@/config/brand';
import { createAnalytics } from './analytics';

const host = new URL(BRAND.url).hostname;

/**
 * The site's analytics: on only in a build given `VITE_GA_MEASUREMENT_ID`
 * (DEPLOYMENT.md) and only on the live site, so local runs and preview
 * deploys never count.
 */
export const analytics = createAnalytics({
  measurementId: import.meta.env.VITE_GA_MEASUREMENT_ID ?? null,
  hosts: [host, `www.${host}`],
});

/**
 * Shows the cookie notice when the visitor hasn't answered yet. Its code loads
 * only then, so someone who already answered never downloads it. Returns a
 * function that takes the notice away again.
 */
export function offerConsent(lang: string | undefined, privacyHref: string): () => void {
  if (analytics.state() !== 'unset') return () => undefined;
  let cancelled = false;
  let remove = (): void => void (cancelled = true);
  void import('./consent-notice').then(({ showConsentNotice }) => {
    if (cancelled || analytics.state() !== 'unset') return;
    remove = showConsentNotice({ lang, privacyHref, onAccept: analytics.grant });
  });
  return () => remove();
}
